import home from './components/home.vue';
import publications from './components/publication.vue';
import service from './components/service.vue';

export default [
    { path: '/', component: home},
    { path: '/publication', component: publications},
    { path: '/service', component: service},
    { path: '*', component: home }
]



// WEBPACK FOOTER //
// ./src/routes.js